module.exports = "<span ng-bind=\"$ctrl.getName()\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control\"\n        ng-class=\"$ctrl.inputClass\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-options=\"opt[0] as opt[0]|uppercase for opt in $ctrl.salesCodes\"\n        ng-if=\"$ctrl.mode === 'edit'\">\n   <option value=\"\">Choose code ...</option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/sales.code.picker.html
// module id = 677
// module chunks = 0